import { createSelector } from 'reselect';
import { connectedPageSelector } from './viewSelectors';
import { StoreState } from '../store-interfaces';
import ConnectedPageModel from '../model/ConnectedPageModel';
import DomainModel from '../model/DomainModel';

const getDomains = (state: StoreState) => state.domain.entities;

const getDomain = (
  domains: DomainModel[],
  connectedPage: ConnectedPageModel,
): Partial<DomainModel> => {
  let foundDomain: DomainModel | undefined;

  if (connectedPage) {
    foundDomain = domains.find(e => e.connectedPageId === connectedPage.id);
  }

  if (!foundDomain) {
    foundDomain = { domainsList: [] };
  }

  return foundDomain;
};

const domainSelector = createSelector(
  [getDomains, connectedPageSelector],
  getDomain,
);

export { domainSelector };
